import React from 'react'
import { connect } from 'react-redux'
import R from 'ramda'
import { Link } from 'react-router'
import {FormattedMessage} from 'react-intl'
import Joyride from 'react-joyride'


import AppContainer from './AppContainer'
import PreSearchForm from './PreSearchForm'

import {fromQueryObject} from '../utils/queryObjectMapper'

import listSearch from '../actions/listSearch'
import registerTourComplition from '../actions/registerTourComplition'

const tourSteps = [
  {
    title:<FormattedMessage id="Select your provinces" defaultMessage="Select your province"/>,
    text:<FormattedMessage 
      id="Select the province in where you want your next estate. You can select multiple provinces." 
      defaultMessage="Select the province in where you want your next estate. You can select multiple provinces."/>,
    selector:".province",
    position:"bottom-left",
  },
  {
    title:<FormattedMessage id="Select your regions" defaultMessage="Select your regions"/>,
    text:<FormattedMessage 
      id="Same with the regions. Only the regions that match the province you selected will be shown. You want more regions, select more provinces." 
      defaultMessage="Same with the regions. Only the regions that match the province you selected will be shown. You want more regions, select more provinces."/>,
    selector:".region",
    position:"bottom-left",
  },
  {
    title:<FormattedMessage id="Select your towns" defaultMessage="Select your towns"/>,
    text:<FormattedMessage 
      id="Same with the towns." 
      defaultMessage="Same with the towns."/>,
    selector:".towns",
    position:"bottom-right",
  },
  {
    title:<FormattedMessage id="Define your own points of interests" defaultMessage="Define your own pointss of interest"/>,
    text:<FormattedMessage 
      id="Adding your points of interest will help us find the perfectly located estate." 
      defaultMessage="Adding your points of interest will help us find the perfectly located estate."/>,
    selector:".poi-entry",
    position:"bottom-left",
  },
  {
    title:<FormattedMessage id="Use the suggestions" defaultMessage="Use the suggestions"/>,
    text:<FormattedMessage 
      id="Here is a list of frequently used points of interest, use them as a source of inspiration for your owns." 
      defaultMessage="Here is a list of frequently used points of interest, use them as a source of inspiration for your owns."/>,
    selector:".suggestions",
    position:"bottom-left",
  },
  {
    title:<FormattedMessage id="Once you're ready" defaultMessage="Once you're ready"/>,
    text:<FormattedMessage 
      id="Once your search fits your need, take a deep breath and click on Search." 
      defaultMessage="Once your search fits your need, take a deep breath and click on Search."/>,
    selector:".search",
    position:"bottom",
  },

]
const locale = {
  back: <FormattedMessage id='Back' defaultMessage="Back"/>, 
  close: <FormattedMessage id="Close" defaultMessage="Close"/>, 
  last: <FormattedMessage id="Last" defaultMessage="Last"/>, 
  next: <FormattedMessage id="Next" defaultMessage="Next"/>, 
  skip: <FormattedMessage id="Skip" defaultMessage="Skip"/>,
}

class PreSearchPage extends React.Component {
  componentDidMount(){
    if(this.props.tourCompleted) {return}
    this.joyride.start()
  }
  componentWillReceiveProps(nextProps){
    if(this.props.tourCompleted && !nextProps.tourCompleted){
      this.joyride.start()
    }
  }  
  render(){
    const props = this.props
    const lang = props.params.locale
    const query = fromQueryObject(props.location.query)
    
    return <AppContainer>
      <div className="content-container">
        <Joyride 
            ref={(c)=> this.joyride = c}
            locale={locale}
            steps={tourSteps}
            type="continuous"
            showStepsProgress={true}
            showSkipButton={true}
            callback={props.onTourEnd}
            />
        <div className="content-container-column">
          <div className="img-pre-search">
            <div className="box-highlight">
              <div className="box-highlight-title"><span><img src="/images/logo/lookupia_blanc.png" style={{width:'20px', marginTop:'-5px', marginRight:'3px'}}/>LOOKUPIA</span></div>
              <div className="box-highlight-content"><p>Commencez votre recherche dès maintenant par emplacement géographique et par points d’intérêts!</p></div>
            </div>
          </div> 
        </div> 
        <div className="content-container-column">
          <div className="form-container pre-search-form-container">
            <PreSearchForm forceSuggestions={true} query={query}/> 

            <div className="button-container" style={{marginTop:'20px'}}>
              <div className="button-spacer"/>

              <Link to={{pathname:`/${lang}/search`, query: props.location.query}}>
                <button className="search btn btn-primary" >
                  <FormattedMessage id="Show" defaultMessage="Show"/>
                </button>
              </Link>
              <div className="button-spacer"/>
            </div>

          </div>
        </div>
      </div>
      </AppContainer>
  }
}
const mapStateToProps = state => ({tourCompleted: state.completedTours.preSearch})
const mapDispatchToProps = dispatch => ({onTourEnd: action => dispatch(registerTourComplition('pre-search', action))})
export default connect(mapStateToProps, mapDispatchToProps)(PreSearchPage)



/** WEBPACK FOOTER **
 ** ./app/components/PreSearch.jsx
 **/